import { render, staticRenderFns } from "./SearchConstructorResultados.vue?vue&type=template&id=5b06170f"
import script from "./SearchConstructorResultados.vue?vue&type=script&lang=js"
export * from "./SearchConstructorResultados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports